import { deviceMappingListQuerySchema, type DeviceMapping, type DeviceMappingListQuery } from '@chukua/common';
import { useMemo } from 'react';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { apiErrorReason } from '../../../policies/api-error-reason.policy';
import { closeDeviceMapping, listDeviceMappings } from '../gps.api';

/** One integration's device mappings (search, sort and paging in the URL) plus ending one: a swap ends the old mapping and adds a new one. */
export function useDeviceMappings(integrationId: string) {
  const list = useListQuery(deviceMappingListQuerySchema);
  const query = useMemo<DeviceMappingListQuery>(() => ({ ...list.query, integrationId: [integrationId] }), [list.query, integrationId]);
  const { state, isRefreshing, reload } = usePagedList(query, listDeviceMappings);
  const toast = useToast();

  async function end(mapping: DeviceMapping): Promise<void> {
    try {
      await closeDeviceMapping(mapping.id, new Date().toISOString());
      await reload();
      toast.success(`${mapping.deviceId} unmapped from ${mapping.truckRegistration}`);
    } catch (err) {
      toast.error(apiErrorReason(err, `Couldn't end the mapping for ${mapping.deviceId}`));
    }
  }

  return { list, state, isRefreshing, reload, end };
}
